import { setLogger } from './logger';
export function configureTwilioWallLogger(logger) {
    setLogger(logger);
}
//# sourceMappingURL=configure_twilio_wall_logger.js.map